import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { TYTCommonModule } from '@tytapp/common';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { routing } from './live-pages.routing';
import { CommonUiModule } from 'common-ui';
import { LiveJumpComponent } from './live-jump/live-jump.component';
import { ArticlesModule } from '@tytapp/articles';
import { WatchLiveComponent } from './watch-live/watch-live.component';
import { LiveSchedulePageComponent } from './live-schedule-page/live-schedule-page.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ChatModule } from '@tytapp/chat';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        HttpClientModule,
        FormsModule,
        ACommonModule,
        TYTCommonModule,
        MediaPlaybackModule,
        CommonUiModule,
        ArticlesModule,
        ChatModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,

        routing
    ],
    declarations: [
        LiveSchedulePageComponent,
        LiveJumpComponent,
        WatchLiveComponent
    ],
    exports: [
        LiveSchedulePageComponent,
        LiveJumpComponent,
        WatchLiveComponent
    ]
})
export class LivePagesModule {
    static forRoot(): ModuleWithProviders<LivePagesModule> {
        return {
            ngModule: LivePagesModule,
            providers: []
        };
    }
}
